import { success } from '@mummssoftware/utils/constants';
import { CPF, PRN } from '@mummssoftware/utils/orders/orders-constants';

/**
 * ORDER READ BACK AND VERIFIED VERIFICATION
 * When isPhysicianRoleGroup: physician verification not required
 */

const getApprovalVerification = (
  verbalDateSeverity: mumms.Severity,
  doctorSeverity: mumms.Severity,
  isPhysicianRoleGroup?: boolean,
) =>
  isPhysicianRoleGroup
    ? true
    : doctorSeverity === success && verbalDateSeverity === success;

const getFreqVerification = (
  VForderData: any,
  verbalDateSeverity: mumms.Severity,
  doctorSeverity: mumms.Severity,
  isPhysicianRoleGroup?: boolean,
) =>
  Object.values(VForderData).length > 0 &&
  getApprovalVerification(
    verbalDateSeverity,
    doctorSeverity,
    isPhysicianRoleGroup,
  );

export const getOrderVerification = (
  ordertype: mumms.DischargeEntityType | mumms.EntityOrderType | null,
  VForderData: any,
  verbalDateSeverity: mumms.Severity,
  doctorSeverity: mumms.Severity,
  isPhysicianRoleGroup?: boolean,
) => {
  switch (ordertype) {
    case CPF:
    case PRN:
      return getFreqVerification(
        VForderData,
        verbalDateSeverity,
        doctorSeverity,
        isPhysicianRoleGroup,
      );
    default:
      return getApprovalVerification(
        verbalDateSeverity,
        doctorSeverity,
        isPhysicianRoleGroup,
      );
  }
};
